import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SepaMandate } from '../models';
import { HttpServices } from './http.service';
import { ReferenceService } from './reference.service';
import * as config from '../config/config';

@Injectable({ providedIn: 'root' })
export class SepaMandateService {
  constructor(
    private httpServices: HttpServices,
    private referenceService: ReferenceService
  ) { }

  fetchSepaMandatesList(): Observable<SepaMandate[]> {
    return this.httpServices.get<SepaMandate[]>(
      this.referenceService.staticReferences.Action[config.ApiKeys.GET_SEPAMANDATE_LIST],
      () => { });
  }

  fetchSupplierListSignSepaInProgress(): Observable<number[]> {
    return this.httpServices.get<number[]>(
      this.referenceService.staticReferences.Action[config.ApiKeys.GET_LIST_SEPA_MANDATE],
      () => { });
  }
}
